import { Config } from '@/models';

const VITE_PREFIX = 'VITE_';

export class Configuration {

  //processEnv = process.env ?? {};
  processEnv = {};

  windowEnv: Config = (window as any).__env__ ?? {};

  config: Config = {} as Config;

  constructor(settings: Config = {} as Config) {
    // Same keys will be overwritten in the order of below spreads
    this.config = {
      ...this.windowEnv, // from public/config.js
      //...this.getCleanProcessEnv(), // from .env file
      ...settings, // from parent; can be from a backend server
    };
  }

  // Remove vite prefix for easier merging
  // Ex. VITE_apiUrl becomes apiUrl
  private getCleanProcessEnv() {
    return Object.entries(this.processEnv).reduce(
      (cleanProcessEnv: any, [key, value]) => {
        cleanProcessEnv[key.replace(VITE_PREFIX, '')] = value;
        return cleanProcessEnv;
      },
      {} as Config,
    );
  }
}
